import CoveredInClassRAv2 from './component';
import Privileges from 'domain/Privileges';
import { PrivilegeChecker } from 'omni-common-ui';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import CoveredInClassRAv2SessionNav from 'components/CoveredInClassRAv2SessionNav';
import { getDefaultSession, getFirstUnitOfSession } from 'data/SessionPlans/accessors';

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'session-nav': {
        component: CoveredInClassRAv2SessionNav,
        order: 1,
      },
    },
  },
  path: 'session/:sessionPlanId(/unit/:unitId)/covered-in-class-ra-v2',
  component: CoveredInClassRAv2,
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.CoveredInClass.ViewCoveredInClass) &&
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.CoveredInClassRAv2),
  tab: {
    label: 'Covered in Class',
    order: 5,
    isVisible: (params) => {
      if (!PrivilegeChecker.hasPrivilege(getState(), Privileges.CoveredInClass.ViewCoveredInClass)) {
        return false;
      }
      if (!TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.CoveredInClassRAv2)) {
        return false;
      }
      // Only show tab if group has session data
      const defaultSession = getDefaultSession(getState(), params.groupId);
      return !!defaultSession;
    },
    params: (currentParams) => {
      const defaultSession = getDefaultSession(getState(), currentParams.groupId);
      const sessionPlanId = defaultSession && defaultSession.id;
      return {
        ...currentParams,
        sessionPlanId,
        unitId: getFirstUnitOfSession(getState(), sessionPlanId),
      };
    },
  },
  breadcrumbLabels: () =>
    [{
      label: 'Covered in Class',
      clickable: false,
    }],
});



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClassRAv2/routes.js